module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/@babel/runtime/regenerator/index.js
// module id = FOhS
// module chunks = 0471